import Head from "next/head"
import { ReactNode } from "react"
import { WithCity } from "app/features/regional-map/regional-map.state"

type LayoutProps = {
  title?: string
  children: ReactNode
}

const SingleFormLayout = ({ title, children }: LayoutProps) => {
  return (
    <WithCity>
      <Head>
        <title>{title || "TESA Login/Signup"}</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <div className="flex h-screen">
        <div className="w-full max-w-xl border-r border-gray-400 bg-gray-100 p-10">
          {children}
          <p className="pl-2 pr-10 pt-5 text-sm text-gray-700">
            Welcome! Log in to get started. If this is your first time, sign up to create a free
            account. Your account ensures that your work on the platform is securely stored for
            future access.
          </p>
        </div>
      </div>
    </WithCity>
  )
}

export default SingleFormLayout
